import { JobService } from "@services/jobs/jobService";
import type { Job } from "@models/job.model";

const LIVE = new Set(["PENDING", "ACTIVE"]);

/*
    The publish still in flight for an engagement, or null (MPN-2232).

    Mirrors the server's rule in CmdPublishEngagement._running_publish, which is what
    refuses a second publish with a 409: a parent no worker has picked up yet, or one with a
    child still running. A parent's own ACTIVE is not enough -- it stays ACTIVE until its
    children roll it up, and some never do. The server stays the authority; this only lets
    the panel say so before the click instead of after.

    Looked up through the jobs list because that is the one endpoint that returns a parent
    with its children. The list has no engagement filter, so the name search narrows it and
    engagement_id (derived server side) makes the match exact.
*/
export async function findRunningPublish(engagementId: number, engagementName: string): Promise<Job | null> {
  const jobs: Job[] = await new JobService().listJobs(50, 0, {
    types: ["PUBLISH_ENGAGEMENT"], statuses: ["PENDING", "ACTIVE"], search: engagementName,
  });
  return jobs.find((job) =>
    job.engagement_id === engagementId
    && (job.status === "PENDING" || (job.children ?? []).some((child) => LIVE.has(child.status))),
  ) ?? null;
}
